import React from 'react';
import styles from './LogoSection.module.css';

const LogoSection = ({ logos}) => {
  return (
    <section className={styles.logoSection}>
      <div className={styles.logoGrid}>
        {logos.map((logo, index) => (
          <div key={index} className={styles.logoItem}>
            <img 
              src={logo.src} 
              alt={logo.alt || `Logo ${index + 1}`}
              className={styles.logoImage}
              style={logo.height ? {height: logo.height } : {}}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default LogoSection;